<!--
  AuthLayout.vue
  ============================
  此元件作為「動物疫情資訊回應平台」的登入頁面版型，包括：
  - 頂部標題（動物疫情資訊回應平台）
  - 動態內容區塊 (RouterView 動態載入頁面元件，主要為Login.vue)
  - 固定在頁面底部的頁尾 (footer) 顯示版權資訊與指導單位文字
-->

<template>
  <VaLayout class="h-screen bg-[var(--va-background-secondary)]">
    <template #content>
      <main class="h-full flex justify-center mx-auto grid grid-flow-row items-start mt-20">
        <div class="flex flex-col">
          <h1 class="font-bold text-4xl text-center">動物疫情資訊回應平台</h1>
          <RouterView class="py-16" />
        </div>
      </main>
      <footer class="footer">
        <div v-if="breakpoint.lgUp" class="footer-content">
          <h5 v-if="breakpoint.lgUp">Copyright © 2024 財團法人農業科技研究院. All Rights Reserved.</h5>
          <h5>指導單位 農業部動植物防疫檢疫署</h5>
        </div>
        <div v-else class="footer-content">
          <h5>© 2024 財團法人農業科技研究院. All Rights Reserved.</h5>
          <h5>指導單位 農業部動植物防疫檢疫署</h5>
        </div>
      </footer>
    </template>
  </VaLayout>
</template>

<script lang="ts" setup>
import { useBreakpoint } from 'vuestic-ui'
import { useI18n } from 'vue-i18n'

const breakpoint = useBreakpoint()
const { t } = useI18n()
</script>

<style lang="scss">
.footer {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  // background-color: #265c83;
  background: linear-gradient(to right, #40826d, lighten(#40826d, 20%));
  color: #ffffff;
}

.footer-content {
  padding: 10px;
  text-align: center;
}
</style>
